export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref7171.cfc62d15.jpg";